module.exports = __webpack_public_path__ + "static/media/white-blue-tick.b5fbf444.svg";